var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticClass:"payments_container",attrs:{"selectedTermProps":_vm.selectedTerm,"selectedProductProps":_vm.selectedProduct,"termProps":_vm.term,"productProps":_vm.product,"activeSyncProps":_vm.activeSync}})
}
var staticRenderFns = []

export { render, staticRenderFns }